
import React, { createContext, useContext, ReactNode } from 'react';
import { usePropertyComparison } from '@/hooks/usePropertyComparison';

interface Property {
  id: string;
  title: string;
  price_egp: number;
  deposit_egp: number;
  distance_km: number;
  unit_type: string;
  furnished: boolean;
  verified: boolean;
  photos: string[];
  amenities: string[];
  available_from: string;
  lease_min_months: number;
  gender_rules: string;
  universities?: {
    name_en: string;
    name_ar: string;
  };
}

interface PropertyComparisonContextType {
  comparisonList: Property[];
  isComparisonOpen: boolean;
  addToComparison: (property: Property) => void;
  removeFromComparison: (propertyId: string) => void;
  clearComparison: () => void;
  openComparison: () => void;
  closeComparison: () => void;
}

const PropertyComparisonContext = createContext<PropertyComparisonContextType | undefined>(undefined);

export const PropertyComparisonProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const comparisonHook = usePropertyComparison();

  return (
    <PropertyComparisonContext.Provider value={comparisonHook}>
      {children}
    </PropertyComparisonContext.Provider>
  );
};

export const usePropertyComparisonContext = () => {
  const context = useContext(PropertyComparisonContext);
  if (context === undefined) {
    throw new Error('usePropertyComparisonContext must be used within a PropertyComparisonProvider');
  }
  return context;
};
